// components/AdminAppointments.js
import React, { useState, useEffect } from "react";
import axios from "axios";

const AdminAppointments = () => {
  const [appointments, setAppointments] = useState([]);

  useEffect(() => {
    const fetchAppointments = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/appointments`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        setAppointments(response.data);
      } catch (err) {
        console.log(err);
      }
    };

    fetchAppointments();
  }, []);

  const handleAccept = async (appointmentId) => {
    try {
      await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/appointments/accept/${appointmentId}`, null, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      setAppointments((prevAppointments) =>
        prevAppointments.map((appointment) =>
          appointment._id === appointmentId
            ? { ...appointment, status: "Accepted" }
            : appointment
        )
      );
    } catch (err) {
      console.log(err);
    }
  };

  const handleCancel = async (appointmentId) => {
    try {
      await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/appointments/cancel/${appointmentId}`, null, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      setAppointments((prevAppointments) =>
        prevAppointments.map((appointment) =>
          appointment._id === appointmentId
            ? { ...appointment, status: "Cancelled" }
            : appointment
        )
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="appointments-container py-4 px-8">
  <h2 className="text-2xl font-bold mb-6 text-white">Appointments</h2>
  <div className="appointments-list space-y-4 bg-blue-900">
    {appointments.map((appointment) => (
      <div key={appointment._id} className="appointment-card p-4 border border-gray-200 rounded-lg shadow-lg text-white">
        <h3 className="text-xl font-semibold">{appointment.clientId.name} - {new Date(appointment.appointmentDate).toLocaleString()}</h3>
        <p className="text-2xl text-white">Date: {appointment.date}</p>
        <p className="text-2xl text-white">Notes: {appointment.notes}</p>
        <p className="text-2xl text-white">Status: {appointment.status}</p>


        {appointment.status === "Pending" && (
          <div className="flex space-x-4 mt-4">
            <button 
              className="bg-green-500 text-white py-1 px-3 rounded hover:bg-green-600" 
              onClick={() => handleAccept(appointment._id)}>
              Accept
            </button>
            <button 
              className="bg-red-500 text-white py-1 px-3 rounded hover:bg-red-600" 
              onClick={() => handleCancel(appointment._id)}>
              Cancel
            </button>
          </div>
        )}
      </div>
    ))}
  </div>
</div>

  );
};

export default AdminAppointments;
